import { Box, Grid, Typography } from "@mui/material";
import owner_wallet_bannerbg from "../../../../../media/images/owner_wallet_bannerbg.svg";
import { addCommas } from "@persian-tools/persian-tools";
import { useAppSelector } from "../../../../../hooks/useRedux";

export default function BannerBox() {
  const { stock } = useAppSelector((state) => state.owner);
  return (
    <Box
      sx={{
        backgroundImage: `
        url(${owner_wallet_bannerbg}),
        linear-gradient(90deg, rgba(217,144,54,0.9360119047619048) 33%, rgba(180,113,30,0.938813025210084) 75%)
            `,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
        justifyContent: "end",
        position: "relative",
        padding: "14px 14px 30px 14px",
        boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.20)",
      }}
    >
      <Grid
        sx={{
          height: "100%",
          justifyContent: "space-between",
        }}
        container
      >
        <Grid item xs={12}>
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              // justifyContent: "space-between",
              paddingLeft: "8px",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: "18px",
              }}
            >
              موجودی:
            </Typography>
            <Box
              sx={{
                alignSelf: "end",
                display: "flex",
                alignItems: "center",
                gap: "3px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "22px",
                  color: "#fff",
                }}
              >
                {addCommas(stock || "0")}
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "#fff",
                  fontWeight: "700",
                }}
              >
                ریال
              </Typography>
            </Box>
          </Box>
        </Grid>
        {/* <Grid item xs={5.5}>
          <Box
            sx={{
              borderRadius: "5px",
              padding: "8px",
              width: "100%",
              backgroundColor: theme.palette.secondary[700],
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <img width={60} src={silverShare} alt="" />
            <Typography
              sx={{
                color: "#fff",
                fontSize: "18px",
                textAlign: "center",
                // fontWeight: "700",
              }}
            >
              اشتراک نقره‌ای
            </Typography>
          </Box>
        </Grid> */}
      </Grid>
      {/* <Box
        sx={{
          position: "absolute",
          bottom: "0px",
          left: "0px",
          width: "100%",
          borderRadius: "0px 0px 10px 10px",
          backgroundColor: theme.palette.secondary[100],
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <img width={24} src={profileImage} />
          <Typography
            sx={{
              color: grey[800],
              fontSize: "14px",
            }}
          >
            {ownerInfo?.surName}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ExpireClockSVG size={14} />
            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              انقضا اشتراک:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: theme.palette.secondary[700],
              fontSize: "12px",
            }}
          >
            04/12
          </Typography>
        </Box>
      </Box> */}
    </Box>
  );
}
